import React from "react";
import {
  BadgeCheck,
  Building2,
  ContactRound,
  MapPinned,
  ShieldCheck,
  Users,
} from "lucide-react";
import { BUSINESS_INFO } from "../../constants/businessInfo";

const ITEMS = [
  {
    title: "Business Registration",
    text: "Registered real estate advisory entity with transparent company profile.",
    icon: BadgeCheck,
  },
  {
    title: "Office Verification",
    text: "Physical office address available for in-person meetings.",
    icon: Building2,
  },
  {
    title: "Professional Team",
    text: "Dedicated advisors for buying, selling, and investment guidance.",
    icon: Users,
  },
  {
    title: "Years of Experience",
    text: `${BUSINESS_INFO.yearsExperience} years of active market experience across Navi Mumbai and Panvel.`,
    icon: ShieldCheck,
  },
  {
    title: "Verified Contact Details",
    text: "Official business email and direct phone assistance are publicly listed.",
    icon: ContactRound,
  },
  {
    title: "Google Maps Verified Office",
    text: "Location details are available on Google Maps for easy verification.",
    icon: MapPinned,
  },
];

const BusinessVerification = ({ className = "" }) => {
  return (
    <section
      className={`rounded-2xl border border-slate-200 bg-white p-6 shadow-sm ${className}`}
      aria-label="Business Verification"
    >
      <h2 className="text-2xl font-semibold text-slate-900">Business Verification</h2>
      <p className="mt-2 text-sm text-slate-600">
        We maintain transparent and verifiable business information for every client.
      </p>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <article
              key={item.title}
              className="rounded-xl border border-slate-200 bg-slate-50 p-4"
            >
              <div className="flex items-center gap-2">
                <Icon className="h-5 w-5 text-blue-700" aria-hidden="true" />
                <h3 className="font-medium text-slate-900">{item.title}</h3>
              </div>
              <p className="mt-2 text-sm text-slate-600">{item.text}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default BusinessVerification;
